/**
 * Level configuration for the Yelken gamification system.
 * Extracted from AccountPage.jsx to be reusable across components.
 */
export const levelConfig = {
  1: { name: 'Çaylak Yelkenci', description: 'İlk adımını attın, rüzgarı hisset!', emoji: '⛵' },
  2: { name: 'Islak Kürekçi', description: 'Henüz ıslandın ama yoldasın!', emoji: '🚣' },
  3: { name: 'Güvertede Çömez', description: 'Geminin dilini öğreniyorsun.', emoji: '📘' },
  4: { name: 'Rüzgar Kaşifi', description: 'Rüzgarla dost olmaya başladın.', emoji: '💨' },
  5: { name: 'Başlangıç Kaptanı', description: 'Yön belirlemeye başladın.', emoji: '⚓' },
  6: { name: 'Azimli Tayfa', description: 'Vira bismillah!', emoji: '💪' },
  7: { name: 'Gözcü', description: 'Ufku tarıyorsun.', emoji: '🔭' },
  8: { name: 'Dalgaların Dostu', description: 'Mücadele etmeyi öğreniyorsun.', emoji: '🌊' },
  9: { name: 'Yolculuğun Çırağı', description: 'Rotaya sadık kalmayı biliyorsun.', emoji: '🗺️' },
  10: { name: 'Yelken Öğreticisi', description: 'Bilgini paylaşma vaktin geldi.', emoji: '📣' },
  11: { name: 'Motivasyon Kaptanı', description: 'Diğerlerine ilham veriyorsun.', emoji: '🔥' },
  12: { name: 'Hedef Avcısı', description: 'Görevleri tek tek indiriyorsun.', emoji: '🎯' },
  13: { name: 'Zihin Yelkencisi', description: 'Akıl ve odak artık seninle.', emoji: '🧠' },
  14: { name: 'Günlük Kahramanı', description: 'Günlük görevler senin işin.', emoji: '🗓️' },
  15: { name: 'Çalışma Savaşçısı', description: 'Zor görevleri pes etmeden tamamlarsın.', emoji: '⚔️' },
  16: { name: 'Rota Ustası', description: 'Planlamada ustalaşıyorsun.', emoji: '🧭' },
  17: { name: 'Strateji Uzmanı', description: 'Öncelik senin için net.', emoji: '📊' },
  18: { name: 'Zaman Efendisi', description: 'Kronometre senin dostun.', emoji: '⏱️' },
  19: { name: 'Zirve Yolu Yolcusu', description: 'Hedef artık çok net.', emoji: '🏔️' },
  20: { name: 'Tecrübeli Tayfa', description: 'Yeni başlayanlara örnek oldun.', emoji: '🛠️' },
  21: { name: 'Forum Kaptanı', description: 'Topluluğun sesi oldun.', emoji: '🗣️' },
  22: { name: 'Günlük Efsanesi', description: 'Her gün aktif olanlar kulübüne hoş geldin.', emoji: '🌟' },
  23: { name: 'Odağı Seven', description: 'Derin odaklanma artık karakterin oldu.', emoji: '🎧' },
  24: { name: 'Görev Avcısı', description: 'Tüm görevleri tıkır tıkır bitiriyorsun.', emoji: '✅' },
  25: { name: 'Mücadeleci Ruh', description: 'Hiçbir şey seni durduramıyor.', emoji: '🥊' },
  26: { name: 'Disiplin Duvarı', description: 'Alışkanlıklarınla duvar örüyorsun.', emoji: '🧱' },
  27: { name: 'Vakit Ustası', description: 'En kıymetli şeyin zaman oldu.', emoji: '⌛' },
  28: { name: 'Günlük Sihirbazı', description: 'Bugünü iyi kullanan yarını yönetir.', emoji: '🪄' },
  29: { name: 'Lig Lideri Adayı', description: 'Zirveye çok yakınsın.', emoji: '🏆' },
  30: { name: 'Usta Kaptan', description: 'Artık bir rol modelsin.', emoji: '🚢' },
  31: { name: 'Zihin Disiplini', description: 'Ruh ve beyin kontrol sende.', emoji: '🧘' },
  32: { name: 'Yıldız Yelkenci', description: 'En yüksek puanları sen topluyorsun.', emoji: '✨' },
  33: { name: 'Hedef Avcısının Efendisi', description: 'Her hedefe bir isabet.', emoji: '🏹' },
  34: { name: 'Streak Efsanesi', description: 'Zincir hiç kopmuyor!', emoji: '🔗' },
  35: { name: 'Motivasyon Meşalesi', description: 'Başkalarına ışık oluyorsun.', emoji: '🕯️' },
  36: { name: 'Zamanın Patronu', description: 'Saat artık seni değil, sen saati yönetiyorsun.', emoji: '🕰️' },
  37: { name: 'Görev Efendisi', description: 'Görev sisteminin ustası oldun.', emoji: '📋' },
  38: { name: 'Bilgi Rüzgarcısı', description: 'Her gün yeni şeyler öğreniyorsun.', emoji: '📖' },
  39: { name: 'Planlama Profesörü', description: 'Hafta, ay, yıl… Her şey senin elinde.', emoji: '📅' },
  40: { name: 'Forumun Feneri', description: 'Yardımınla herkes ilerliyor.', emoji: '🏮' },
  41: { name: 'Günlük Titan', description: 'Her gün her şeyi yapıyorsun.', emoji: '🦁' },
  42: { name: 'Kararlılık Kumandanı', description: 'Sarsılmaz bir irade!', emoji: '🛡️' },
  43: { name: 'Görevlerin Kralı', description: 'Bir kral gibi ilerliyorsun.', emoji: '👑' },
  44: { name: 'Süper Kaptan', description: 'Gemini sen inşa ettin.', emoji: '🌊' },
  45: { name: 'Zihin Mühendisi', description: 'Beynini mükemmel yönetiyorsun.', emoji: '⚙️' },
  46: { name: 'Zaman Yolcusu', description: 'Geleceğini inşa ediyorsun.', emoji: '⏳' },
  47: { name: 'İlham Veren', description: 'Herkes seni örnek alıyor.', emoji: '💡' },
  48: { name: 'Efsane Tayfa', description: 'Seni herkes tanıyor.', emoji: '🏅' },
  49: { name: 'Sonsuz Rüzgar', description: 'Artık sınır yok.', emoji: '🌬️' },
  50: { name: 'Yelken Efsanesi', description: 'Platformun zirvesindesin.', emoji: '🌟' },
};

/**
 * Get level info by level number.
 * @param {number} level
 * @returns {{ name: string, description: string, emoji: string }}
 */
export function getLevelInfo(level) {
  return levelConfig[level] || { name: 'Bilinmeyen', description: '', emoji: '❓' };
}

export const XP_PER_LEVEL = 100;
